import { render, staticRenderFns } from "./FormularTextarea.vue?vue&type=template&id=6010207a&v-if=actualformular&"
import script from "./FormularTextarea.vue?vue&type=script&lang=js&"
export * from "./FormularTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports